export const INCUBATOR_VC_NAMES = [
  '212 VC',
  '360 Capital VC',
  '36n',
  '42entrepreneurs',
  '500 Portfolio',
  '500 Startups',
  '645 Ventures',
  'Activate Studio',
  'AI Forge',
  'Alchemist Accelerator',
  'Algolia',
  'Allegis Capital',
  'American Underground',
  'Anthill Ventures',
  'Antler',
  'Applify',
  'APX',
  'Asan Nanum Foundation',
  'Astella',
  'Atomic',
  'Atomico',
  'Attio Startup Program',
  'Aurelia Ventures',
  'Axibator',
  'BACKED VC',
  'Baseline',
  'BBVA Spark - Columbia',
  'BBVA Spark - Spain',
  'BCGDV',
  'BDev Ventures',
  'Berkeley Skydeck',
  'Berrywood Capital',
  'Beyond the Lab by E14 Fund',
  'BHeroes',
  'Bifrost Studios',
  'Blackbird Ventures',
  'Boomtown Accelerators',
  'Boost Capital Partners',
  'BoxGroup',
  'Bread & Butter Ventures',
  'Build Up Labs',
  'BuiltFirst',
  'Caddie Group',
  'Calm Company Fund',
  'Canary',
  'Capital Klub',
  'Cardumen Capital',
  'Catalyst Fund',
  'Climate Vine',
  'Company Ventures',
  'Concentric VC',
  'Concrete Ventures',
  'Creandum',
  'Crosslink Capital',
  'CultTech Accelerator',
  'CyRise',
  'DCVC',
  'Demium',
  'DMZ',
  'Downtown Works',
  'DraperX BTC Studio',
  'Eight Roads',
  'Elevate',
  'Ensemble',
  'Enterprise Ireland',
  'Entrepreneurs Collective',
  'ERA',
  'Eura Technologies',
  'Eurazeo',
  'EVCA',
  'Exponential Impact',
  'F6S',
  'Failup Ventures',
  'Featured.com',
  'Fiat Growth',
  'Fisher VB',
  'Flex Capital',
  'Flourish Ventures',
  'Flyerone',
  'Forum Ventures (formerly Acceleprise)',
  'Founder Institute HQ',
  'Founder Summit',
  'Founder-Led Marketing Club',
  "Founder's Network",
  'FounderPass Premium',
  'Founders Factory',
  'Founders Foundation',
  'Founders, Inc.',
  'Foundry Group/Foundry Network',
  'Frst VC',
  'FRTN Technologies',
  'Fuel Ventures',
  'Fundify',
  'Fusion42',
  'FutureList',
  'GAN',
  'Gener8tor',
  'Genesia Ventures',
  'Genisis Tech',
  'Global Founders Capital GFC',
  'Gold House',
  'Grad Capital',
  'Griffin Gaming Partners',
  'Haatch',
  'HALA Ventures',
  'Hampton',
  'Headstart',
  'Heavybit',
  'Hetch',
  'Highlander',
  'HOOK',
  'House of Ventures',
  'Hubblr.io',
  'Hypernest',
  'Hyppo',
  'iBenjamen Studio',
  'Idacapital VC',
  'Incutex',
  'Isai',
  'Israeli Startups',
  'Iterative VC',
  'Iverksetter',
  'Jackson Square Ventures',
  'K Fund',
  'Kalaari Capital',
  'Kapor Capital',
  'KBC Accelerator',
  'Keyhorse Capital',
  'Khosla Ventures',
  'Kogito Ventures',
  'Komünite',
  'KWORKS',
  'Las Olas Venture Capital (LOVC)',
  'Latitud',
  'Leap by DIFC',
  'Learn Launch',
  'Leyden VC',
  'Lightspeed Venture Partners LSVP',
  'LoftyInc Capital',
  'Loot Discount Inc',
  'M13',
  'Madica Ventures',
  'Madrona Venture Group',
  'Mastercard Business Card Perk',
  'Matter Venture Partners',
  'Melon',
  'Mercury',
  'Metaplanet',
  'Mindset Ventures',
  'MIT delta v',
  'Modus Capital',
  'Mogul Millennial',
  'Morado One Services',
  'Mudcake',
  'Munich Re Ventures',
  'MYSTARTUP',
  'n2',
  'NachoNacho',
  'Neuillylab',
  'Newtopia VC',
  'Next AI',
  'Nextway Tech',
  'NFX Portfolio',
  'Northwestern Mutual Future Ventures',
  'Novapuls',
  'Nucleus Ventures',
  'On Deck',
  'Panache Ventures',
  'Pantera Capital',
  'Parcel',
  'Peachscore',
  'Peekaboo',
  'Pegasus Angel Accelerator',
  'Pelion Venture Partners',
  'Picus',
  'Pitchdrive',
  'PitGrowth',
  'Platanus Ventures',
  'Platvix',
  'Point72 Ventures',
  'Precursor',
  'Primary Venture Partners',
  'Product Hunt',
  'Project Europe',
  'Punch Financial',
  'Purple Ventures',
  'Quiet Capital',
  'Raise Ventures',
  'Red Alpine',
  'Redesign Health',
  'Redpoint',
  'Retool',
  'RevRoad',
  'Rifatela',
  'Right Side Capital',
  'Rockethub',
  'Rogers Cybersecure Catalyst',
  'Runa Capital',
  'SaaS Academy',
  'Sawo Labs',
  'SC Ventures',
  'Sebrae Startups',
  'Secret',
  'Seedcamp',
  'Seedstars',
  'Segment Startup Program',
  'Seven Stars',
  'Shift',
  'Sierra Ventures',
  'Silicon Gardens',
  'Skala',
  'SmartGateVC',
  'South Park Commons',
  'Speedinvest',
  'Square Peg',
  'StageXero',
  'Start Co',
  'Startmate',
  'Startup Grind',
  'Startup Health',
  'Startup Lisboa',
  'Startup People',
  'Startupbootcamp',
  'Starve Ups',
  'Station F',
  'Stirring Minds',
  'Stone and Chalk',
  'Supercharger Ventures',
  'Swiss Founders Fund - SFF VC',
  'TBA',
  'Tech for Black Founders',
  'TechCrunch',
  'TechStars',
  'Ten Eleven Ventures',
  'Terminal Istanbul',
  'The Factory',
  'The Family',
  'The Moon Venture',
  'The Spartan Group',
  'The Venture City',
  'Theanna',
  'Thrive Capital',
  'TinySeed',
  'Toyota Ventures',
  'UCalgary & Innovate Calgary Venture Backbone',
  'ULTRA.VC',
  'ULU Ventures',
  'Uncork Capital',
  'Underline VC',
  'Upfront Ventures',
  'Upside VC',
  'Uretken Akademi',
  'Vector 3',
  'Venista',
  'Vento Ventures',
  'Venture Development Institute VDI',
  'Venture Highway',
  'Vertex Ventures Israel',
  'Vestbee',
  'Village Global',
  'Vive Collective',
  'Vodafone Innovation Hub',
  'Wavemaker VC',
  'WEtech Alliance',
  'WeWorkLabs',
  'Wing Ventures',
  'xdeck',
  'XRaise',
  'yCombinator',
  'Yuma',
  'Zenith Workspace',
  'Zest',
  'Zinc VC',
  "I don't see my partner listed",
  'I am a Bootstrapped startup',
];

export const INCUBATOR_VC_OPTIONS = INCUBATOR_VC_NAMES.map((name) => ({ value: name, label: name }));

export const STARTUP_FUNDING_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: '0_to_2_99m', label: '$0-$2.99M' },
  { value: '3m_to_5_99m', label: '$3M - $5.99M' },
  { value: '6m_to_10m', label: '$6M - $10M' },
  { value: '10m_plus', label: '$10M+' },
];

export const HEARD_ABOUT_US_OPTIONS = [
  { value: 'google_search', label: 'Google Search' },
  { value: 'social_media', label: 'Social media' },
  { value: 'word_of_mouth', label: 'Word of mouth' },
  { value: 'customerio_website', label: 'Customer.io website' },
  { value: 'other', label: 'Other' },
];
